document.addEventListener('DOMContentLoaded', function () {
  const groups = document.querySelectorAll('[data-combo-tabs]');

  groups.forEach((group) => {
    const buttons = group.querySelectorAll('.fs-tab-btn');
    const panels = group.querySelectorAll('.fs-tab-content');

    buttons.forEach((button) => {
      button.addEventListener('click', function () {
        const targetId = button.getAttribute('data-tab-target');
        const target = group.querySelector('#' + CSS.escape(targetId));

        buttons.forEach((btn) => btn.classList.remove('active'));
        panels.forEach((panel) => panel.classList.remove('active'));

        button.classList.add('active');

        if (target) {
          target.classList.add('active');
        }
      });
    });
  });
});